import { Dropdown, TooltipV2 } from '@cimplico/components';
import { useUserContext } from '../../../providers/UserProvider';
import { Reply } from '../../../types/reply';
import { calcRelativeTime, formatDateTime } from '../../../utilities/formatting';
import Editor from '../../rich-text-editor/Editor';
import UserAvatar from '../../avatar/UserAvatar';
import { InternalCommentReply } from '../../../types/internal-comment';
import { ClientQueryReply } from '../../../types/client-query';

type ReplyRowProps = {
    reply: InternalCommentReply | ClientQueryReply;
    disableActions?: boolean;
    showMenu: boolean;
    onEdit?: (rawReply: string, structuredReply: string) => void;
    onDelete?: () => void;
};

function ReplyRow({ reply, disableActions = false, showMenu, onEdit, onDelete }: ReplyRowProps): JSX.Element {
    const { id } = useUserContext();

    return (
        <div className="mt-4 group">
            <div className="flex gap-2 items-center">
                <UserAvatar user={reply.createdBy} />
                <p className="text-xs font-medium text-gray-800">
                    {reply.createdBy.firstName} {reply.createdBy.lastName}
                </p>
                <TooltipV2 message={formatDateTime(reply.updatedAt)} position="right">
                    <p className="text-gray-500 text-xs">{calcRelativeTime(reply.updatedAt)}</p>
                </TooltipV2>
                {showMenu && reply.createdBy.id === id && (
                    <div className="ml-auto mr-2 block">
                        <Dropdown disabled={disableActions} direction="bottom" dotsDirection="horizontal">
                            <Dropdown.Option
                                label="Edit"
                                value="edit"
                                onClick={(): void => onEdit && onEdit(reply.rawReply, JSON.stringify(reply.structuredReply))}
                            />
                            <Dropdown.Option label="Delete" value="delete" onClick={(): void => onDelete && onDelete()} />
                        </Dropdown>
                    </div>
                )}
            </div>
            <Editor defaultContent={reply.structuredReply ? JSON.stringify(reply.structuredReply) : undefined} readOnly isReplyContent />
        </div>
    );
}
export default ReplyRow;
